/**
 * useBugCapture Hook
 * Provides methods for capturing bug report context including
 * screenshots, console logs, network errors, and browser context.
 */
import html2canvas from 'html2canvas';
import { getConsoleLogs } from '../services/consoleCapture';
import { getNetworkErrors } from '../services/networkCapture';

export const useBugCapture = () => {
  const captureScreenshot = async () => {
    try {
      const canvas = await html2canvas(document.body, {
        logging: false,
        useCORS: true,
        scale: 1
      });
      return canvas.toDataURL('image/png');
    } catch (error) {
      console.error('Screenshot capture failed:', error);
      return null;
    }
  };

  const captureConsoleLogs = () => {
    return getConsoleLogs();
  };

  const captureNetworkErrors = () => {
    return getNetworkErrors();
  };

  const captureBrowserContext = () => ({
    userAgent: navigator.userAgent,
    viewport: { width: window.innerWidth, height: window.innerHeight },
    url: window.location.href,
    timestamp: new Date().toISOString(),
    language: navigator.language,
    platform: navigator.platform,
    cookiesEnabled: navigator.cookieEnabled
  });

  const captureAll = async () => ({
    screenshot: await captureScreenshot(),
    consoleLogs: captureConsoleLogs(),
    networkErrors: captureNetworkErrors(),
    browserContext: captureBrowserContext()
  });

  return {
    captureScreenshot,
    captureConsoleLogs,
    captureNetworkErrors,
    captureBrowserContext,
    captureAll
  };
};
